module.exports = __webpack_public_path__ + "a17d279f/img/grid-web-icon.d0395d64.svg";